import { ComponentsOverrides, ComponentsProps } from "@mui/material/styles";

import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { COLOR_SKELETON } from "../colors";

export const getMuiSkeleton = (): ComponentsOverrides["MuiSkeleton"] => {
  return {
    root: {
      backgroundColor: COLOR_SKELETON,
      maxWidth: "100%",
    },
  };
};

export const getMuiSkeletonDefaultProps = (): ComponentsProps["MuiSkeleton"] => ({
  variant: "rounded",
  ...getTestAutomationProps("skeleton"),
});
